import { createSlice } from "@reduxjs/toolkit";

const cashoutSlice = createSlice({
  name: "cashout",
  initialState: null,
  reducers: {
    setCashout(state, action) {
      state = action.payload;

      return state;
    },
    clearCashout(state) {
      state = null;

      return state;
    },
    fakeAutoBetCashout(state, action) {
      state = action.payload;

      return state;
    }
  }
});

export const { clearCashout, fakeAutoBetCashout, setCashout } = cashoutSlice.actions;
export default cashoutSlice.reducer;
